import { Element } from "@xmpp/xml"
import { jid } from "@xmpp/client"

type Presence = {
  type: "connected" | "disconnected"
  from: ReturnType<typeof jid.parse>
  chat: string
  user: string
  statuses: number[]
  selfPresence?: boolean
  shouldUpdateVcard?: boolean
}

export default class PresenceParser {
  static parse(stanza: Element): Presence | undefined {
    if (!stanza.getAttr("from")) return

    const from = jid.parse(stanza.getAttr("from"))
    const type = stanza.getAttr("type")

    const isPresenceFromMuc = Boolean(
      stanza.getChild("x", "http://jabber.org/protocol/muc#user"),
    )

    const statuses =
      stanza
        .getChild("x", "http://jabber.org/protocol/muc#user")
        ?.getChildren("status")
        .map((status) => Number(status.getAttr("code"))) ?? []

    // Check if the presence has the driver added vcard update
    const driverAddedVcardUpdate = Boolean(
      stanza.getChild("x", "urn:slickshift:vcard-update"),
    )

    // If the presence is from a MUC, we don't want to update the vcard
    const presenceVcardUpdate =
      !isPresenceFromMuc && Boolean(stanza.getChild("x", "vcard-temp:x:update"))

    // If the presence is for disconnected, we don't want to update the vcard
    const shouldUpdateVcard =
      type !== "unavailable" && (driverAddedVcardUpdate || presenceVcardUpdate)

    const user = from.resource
    const chat = from.bare().toString()

    return {
      type: type === "unavailable" ? "disconnected" : "connected",
      from,
      chat,
      user,
      statuses,
      selfPresence: statuses.includes(110),
      shouldUpdateVcard,
    }
  }
}
